"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/ZAFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_255)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_255`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-2.51999 0.000305176H33.48V23.9998H-2.51999V0.000305176Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M5.49733 12.0001L-2.51999 3.97919V20.0224L5.49733 12.0001Z",
					fill: "black"
				}),
				/* @__PURE__ */ n("path", {
					d: "M8.81383 12L-2.51999 0.65863V3.97921L5.49733 12.0001L-2.51999 20.0224V23.3368L8.81383 12Z",
					fill: "#FFB915"
				}),
				/* @__PURE__ */ n("path", {
					d: "M33.3277 14.3479C33.3318 14.3169 33.3842 14.2861 33.48 14.2552V9.65225H13.1317L3.47978 0.000305176H-2.51999V0.658642L8.81383 12.0001L-2.51999 23.3368V23.9998H3.47978L13.1317 14.3479H33.3277Z",
					fill: "#007847"
				}),
				/* @__PURE__ */ n("path", {
					d: "M32.8599 16.6957H14.1042L6.80005 23.9998H33.48V16.6957H32.8599Z",
					fill: "#000C8A"
				}),
				/* @__PURE__ */ n("path", {
					d: "M32.8599 7.30437H33.48V0.000305176H6.80005L14.1042 7.30437H32.8599Z",
					fill: "#E1392D"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_255`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as ZAFlag };
